import React from 'react';
import { motion } from 'framer-motion';
import { CloudIcon } from 'lucide-react';
export function ProblemSection() {
  return <section className="w-full bg-gradient-to-b from-cream to-warmWhite py-20 px-4" data-id="element-200">
      <motion.div className="max-w-4xl mx-auto text-center" initial={{
      opacity: 0,
      y: 40
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.7,
      ease: 'easeOut'
    }} data-id="element-201">
        <div className="flex justify-center mb-6" data-id="element-202">
          <CloudIcon className="w-10 h-10 text-sage-300" data-id="element-203" />
        </div>

        <h2 className="font-heading text-3xl sm:text-4xl text-charcoal mb-8" data-id="element-204">
          El problema que nadie te contó
        </h2>

        <p className="font-body text-lg sm:text-xl text-warmGray leading-relaxed mb-8" data-id="element-205">
          Has pasado meses intentando "aguantar". Te dijeron que a los tres
          meses todo mejoraba, pero tu bebé sigue despertando cada 45 minutos.
          Estás viviendo en una neblina de fatiga que te impide disfrutar de tu
          maternidad, te hace discutir con tu pareja y te hace sentir que estás
          fallando en lo más básico.
        </p>

        <div className="bg-terracotta-50 rounded-2xl p-6 sm:p-8 border border-terracotta-100" data-id="element-206">
          <p className="font-heading text-xl sm:text-2xl text-charcoal italic" data-id="element-207">
            El problema no es tu bebé, ni tampoco tu instinto. El problema es
            que estás intentando calmar el sueño con métodos que{' '}
            <span className="text-terracotta font-semibold" data-id="element-208">
              ignoran la biología del estrés infantil
            </span>
            .
          </p>
        </div>
      </motion.div>
    </section>;
}